/**
 * @description 複選框元件，提供 Material Design 風格的複選框功能
 * @class JkcheckboxComponent
 * @extends {JkBaseComponent}
 * @implements {OnInit}
 */
import {
  Component,
  Input,
  OnInit,
  output,
  ChangeDetectionStrategy
} from '@angular/core';
import { JkBaseComponent } from '../jkbase/jkbase.component';
//import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // 新增這行
import {
  MatCheckboxModule,
} from '@angular/material/checkbox';
import { jkLib } from '../../services/jkCommon';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-jkcheckbox',
  templateUrl: './jkcheckbox.component.html',
  styleUrls: ['./jkcheckbox.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule, // 新增這行
    //BrowserAnimationsModule, // 新增這行
    MatCheckboxModule,
  ],
})
export class JkcheckboxComponent extends JkBaseComponent implements OnInit {
  override comType: string = 'jkcheckbox';
  //private _value: boolean = false;
  _value: boolean = false;
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set value(value: boolean) {
    this._value = value;
  }

  get value(): boolean {
    return this._value;
  }

  readonly valueChange = output<boolean>();

  onCheckboxChange(event: any) {
    this._value = event.checked;
    this.valueChange.emit(this._value);
  }
  constructor() {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  addWhere(where: string,fieldName:string): string {
      where = jkLib.bool2Where(this.value, where, fieldName);
      return where;
  }
}
